import React from "react";
import { useIntercom } from "react-use-intercom";

import crypto from "crypto";

import Support from "../assets/svg/other/support.svg";
import { useStore } from "store/index";
import configs from "../config/constant";
export default function Coms() {
  const { boot } = useIntercom();

  const { store } = useStore();

  const userData = store?.userData;

  const bootConfig = {
    name: userData.firstName,
    userId: userData.userId,
    email: userData.email,
    phone: userData.phone || undefined,
    createdAt: userData.createdAt,
    utmSource: "web",
  };

  if (configs.INTERCOM_SECRET && String(configs.INTERCOM_SECRET).length > 0) {
    const userHash = crypto
      .Hmac("sha256", configs.INTERCOM_SECRET)
      .update(userData?.userId)
      .digest("hex");

    Object.assign(bootConfig, { userHash });
  }

  const bootWithProps = () => boot(bootConfig);

  return (
    <div>
      {/* <button onClick={boot}>Boot intercom! ☎️</button> */}
      <img onClick={bootWithProps} src={Support} alt="support" />
    </div>
  );
}
